var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-echarts',{attrs:{"option":_vm.chartOption}})
}
var staticRenderFns = []

export { render, staticRenderFns }